export const SIGNUP_INTENTS = ["mfp"] as const;
export type SignupIntent = (typeof SIGNUP_INTENTS)[number];

export const SIGNUP_INTENT_PARAM = "intent";
const SIGNUP_INTENT_STORAGE_KEY = "signupIntent";

const parseSignupIntent = (value: string | null): SignupIntent | undefined =>
  SIGNUP_INTENTS.find((intent) => intent === value);

export const readSignupIntent = (query: URLSearchParams): SignupIntent | undefined => {
  const fromUrl = parseSignupIntent(query.get(SIGNUP_INTENT_PARAM));
  if (fromUrl) return fromUrl;
  try {
    return parseSignupIntent(sessionStorage.getItem(SIGNUP_INTENT_STORAGE_KEY));
  } catch {
    return undefined;
  }
};

export const rememberSignupIntent = (intent: SignupIntent) => {
  try {
    sessionStorage.setItem(SIGNUP_INTENT_STORAGE_KEY, intent);
  } catch {
    // sessionStorage unavailable
  }
};

export const forgetSignupIntent = () => {
  try {
    sessionStorage.removeItem(SIGNUP_INTENT_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
};
